export default {
  confirmed_and_probable_cases: [
    '#efefef',
    '#BEE9F4',
    '#8FD0E1',
    '#60B7D3',
    '#3995B7',
    '#026F90',
    '#00435c',
  ],
  confirmed_deaths: [
    '#efefef',
    '#dadfe1',
    '#c2cad3',
    '#a3b6c8',
    '#829db0',
    '#5d7786',
    '#46525f',
  ],
  confirmed_cases: [
    '#efefef',
    '#BEE9F4',
    '#8FD0E1',
    '#60B7D3',
    '#3995B7',
    '#026F90',
    '#00435c',
  ],
  confirmed_cases: [
    '#efefef',
    '#BEE9F4',
    '#8FD0E1',
    '#60B7D3',
    '#3995B7',
    '#026F90',
    '#00435c',
  ],
  deaths: [
    '#efefef',
    '#dadfe1',
    '#c2cad3',
    '#a3b6c8',
    '#829db0',
    '#5d7786',
    '#46525f',
  ],
};
